
  import DetailsModule from './DetailsModule.vue'
  export default {
    components: { DetailsModule },
    computed: {
        orderDetailed() {
          return this.$route.params.order
        },
    },
    beforeDestroy() {
      this.$store.commit('setCreatedFairpay', null)
      this.$store.commit('setSession', null)
    }
}
  